/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ top: NonNullable<unknown>, days: NonNullable<unknown>, n: NonNullable<unknown> }} Leveling_Reward_TopInputs */



/**
* | output |
* | --- |
* | "Top {top} over {days} days" |
*
* @param {Leveling_Reward_TopInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_reward_top = /** @type {((inputs: Leveling_Reward_TopInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Reward_TopInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`Топ-${i?.top} за ${i?.days} день`);
		if (form === "few") return /** @type {LocalizedString} */ (`Топ-${i?.top} за ${i?.days} дня`);
		if (form === "many") return /** @type {LocalizedString} */ (`Топ-${i?.top} за ${i?.days} дней`);
		return /** @type {LocalizedString} */ (`Топ-${i?.top} за ${i?.days} дня`)
	}
	return /** @type {LocalizedString} */ (`Top ${i?.top} over ${i?.days} days`)
});